import { useCallback } from "react";
import { debounce } from "lodash";
import { Icon } from "assets/icons";

import { TextInput } from "components/TextInput/TextInput";

import styles from "./styles.module.scss";

type SearchInputProps = {
  callback: (product: string) => void;
  placeholder?: string;
};

const TIMEOUT = 500;

export const SearchInput = ({
  callback,
  placeholder = "Поиск",
}: SearchInputProps): JSX.Element => {
  const debouncedCb = useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      callback(event.target.value);
    }, TIMEOUT),
    []
  );

  return (
    <div className={styles.searchInput}>
      <TextInput
        onChange={debouncedCb}
        className={styles.input}
        placeholder={placeholder}
      />
      <span className={styles.searchIcon}>
        <Icon type="search" size={16} />
      </span>
    </div>
  );
};
